<template>
  <section class="player">
    <div class="player__control">
      <div class="player__info-box">
        <time class="player__current-time">{{ isFocusTheAudio ? currentTimeFormat : '00:00' }}</time>
        <CurrentTimecode 
          class="player__current-timecode" 
          :text="currentTimecode.text" 
          v-if="podcast?.timecodes" 
          @click="activeTimecode()"
        />
        <time class="player__remaining-time">{{ isFocusTheAudio ? remainingTimeFormat : durationTimeAudioFormat }}</time>
      </div>
      <ProgressBar class="player__progress" :idPodcast="props.idPodcast"/>
      <div class="player__interactive-items">
        <SpeedStatus class="player__speed" />
        <AudioControlsGroup class="player__aduio-controls-group" :idPodcast="props.idPodcast" />
        <VolumeStatus class="player__volume" :isHideBar="isLessThanSM"/>
      </div>
    </div>
    <div class="player__timecodes" v-if="podcast?.timecodes">
      <p class="player__timecodes-ttl">Таймкоды</p>
      <TimecodesList :idPodcast="props.idPodcast" :gradient="'var(--gradient-bg-primary)'"/>
    </div>
  </section>
</template>

<script setup>
  import { Props } from './props';
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  import { isLessThanSM } from '@shared/composables/screenWidth/useScreenSize';
  import { useAudioControl } from '@/Groups/Audioplayer/private/composables/audioControl';
  import { useAudioPlayerState } from '@/Groups/Audioplayer/private/composables/computedValues';
  //------------------------
  import AudioControlsGroup from '@/Groups/Audioplayer/private/core/AudioControlsGroup/AudioControlsGroup.vue';
  import SpeedStatus from '@/Groups/Audioplayer/private/core/SpeedStatus/SpeedStatus.vue';
  import VolumeStatus from '@/Groups/Audioplayer/private/core/VolumeStatus/VolumeStatus.vue';
  import ProgressBar from '@/Groups/Audioplayer/private/core/ProgressBar/ProgressBar.vue';
  import TimecodesList from '@/Groups/Audioplayer/private/core/TimecodesList/TimecodesList.vue';
  import CurrentTimecode from '@/Groups/Audioplayer/private/ui/CurrentTimecode/CurrentTimecode.vue';
  //------------------------
  const store = useStore();
  const props = defineProps(Props());
  //------------------------
  const { 
    currentTimeFormat, 
    remainingTimeFormat, 
    durationTimeAudioFormat, 
    currentTimecodeId, 
    podcast 
  } = useAudioPlayerState();
  //------------------------
  const { seekToTime } = useAudioControl();
  //------------------------
  //Определить теущий таймкод
  const currentTimecode = computed(() => {
    if(store.state.Audioplayer.activePodcastId == props.idPodcast){
      return { text: podcast.value.timecodes[`${currentTimecodeId.value}`], time: currentTimecodeId.value };
    }else{
      return { text: podcast.value.timecodes['0'], time: 0};
    }
  })
  //Фокус на этом подкасте
  const isFocusTheAudio = computed(() => {
    return store.state.Audioplayer.activePodcastId == props.idPodcast;
  });
  //------------------------
  //Активировать таймкод
  const activeTimecode = () => {
    seekToTime(currentTimecode.value.time, props.idPodcast);
  }
</script>

<style scoped lang="scss">
  @import "./styles.scss";
</style>